import type {
  Action,
  ListingWrapperState,
} from '@utility/reducers/ListingWrapper';
import { createContext, Dispatch, PropsWithChildren, useContext } from 'react';

const StateContext = createContext<ListingWrapperState | null>(null);
const DispatchContext = createContext<Dispatch<Action> | null>(null);

type ProviderProps = PropsWithChildren<{
  state: ListingWrapperState;
  dispatch: Dispatch<Action>;
}>;

export const ListingProvider = ({
  state,
  dispatch,
  children,
}: Readonly<ProviderProps>) => (
  <StateContext.Provider value={state}>
    <DispatchContext.Provider value={dispatch}>
      {children}
    </DispatchContext.Provider>
  </StateContext.Provider>
);

export const useListingState = () => {
  const state = useContext(StateContext);

  if (!state)
    throw new Error('useListingState must be used within <ListingProvider>');
  return state;
};
export const useListingDispatch = () => {
  const dispatch = useContext(DispatchContext);
  if (!dispatch)
    throw new Error('useListingDispatch must be used within <ListingProvider>');
  return dispatch;
};
